import { globalABTests } from '@bridebook/web/app-basic/lib/ab-tests/tests/global';

/**
 * Hook initializes all AB Tests that should be triggered on any page load
 */
export const useGlobalABTests = () => {
  globalABTests.forEach((testHook) => testHook());
};
